import React from "react";
import Page from "../templates/conserve/energy/energypage";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>
          Energy Conservation | Achievements and Targets | Hirdaramani
        </title>
        <meta
          name="title"
          content="Energy Conservation | Achievements and Targets | Hirdaramani"
        />
        <meta
          name="description"
          content="At Hirdaramani, we're dedicated to reducing our carbon footprint. Learn how our mission to explore and innovate drives energy efficiency across our operations."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/conserve/energy/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Energy Conservation" />
        <meta
          property="og:title"
          content="Energy Conservation | Achievements and Targets | Hirdaramani"
        />
        <meta
          property="og:description"
          content="At Hirdaramani, we're dedicated to reducing our carbon footprint. Learn how our mission to explore and innovate drives energy efficiency across our operations."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/conserve/energy/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
